const getters = {
  getKPIPackages: (state) => state.packages,
  getKPIInsights: (state) => state.insights,
  getKPITags: (state) => state.tags,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/modules/kpis/getters.js